import React, { FC } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {
  SuggestionsContainer,
  SuggestionsDesign,
} from "../../../styles/ChatBot/Suggestions.style";
import { useTranslation } from "react-i18next";

interface ISuggestions {
  askedQuestions: string[];
  handleClick: (question: string) => void;
}

const Suggestions: FC<ISuggestions> = ({ askedQuestions, handleClick }) => {
  const { t } = useTranslation();
  return (
    <Box sx={SuggestionsContainer}>
      {askedQuestions.map((question, index) => (
        <Typography
          key={index}
          sx={SuggestionsDesign}
          onClick={() => handleClick(t(question.charAt(0).toUpperCase() + question.slice(1)))}
        >
          {t(question.charAt(0).toUpperCase() + question.slice(1))}
        </Typography>
      ))}
    </Box>
  );
};

export default Suggestions;
